import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import es from './locales/es.json'
import en from './locales/en.json'
import pt from './locales/pt.json'
import { getInitialLanguage, DEFAULT_LANGUAGE } from './detectLanguage'

const resources = {
  es: { translation: es },
  en: { translation: en },
  pt: { translation: pt },
}

const initialLanguage = getInitialLanguage()

function syncDocumentLanguage(lng) {
  if (typeof document === 'undefined') return
  const code = String(lng || initialLanguage).split('-')[0]
  document.documentElement.lang = code
}

i18n.use(initReactI18next).init({
  resources,
  lng: initialLanguage,
  fallbackLng: DEFAULT_LANGUAGE,
  supportedLngs: ['es', 'en', 'pt'],
  nonExplicitSupportedLngs: true,
  interpolation: {
    escapeValue: false,
  },
})

syncDocumentLanguage(initialLanguage)

i18n.on('languageChanged', (lng) => {
  syncDocumentLanguage(lng)
})

export { getInitialLanguage, DEFAULT_LANGUAGE }
export default i18n
